import { Box, keyframes, styled } from '@mui/material'

import flag from '@/assets/images/flag.svg'
import { theme } from '@/theme/theme'

const waveAnimation = keyframes`
   0% { transform: scaleX(1) ; transform-origin: right;}
  50% { transform:scaleX(0.95); transform-origin: right;} 
  100% { transform: scaleX(1) ; transform-origin: right;}
`

const Flag = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <StyledImg src={flag} alt="Flag" />
    </Box>
  )
}

const StyledImg = styled('img')(() => ({
  width: '40px',
  position: 'absolute',
  right: theme.spacing(-0.5),
  animation: `${waveAnimation} 2s ease-in-out infinite`,
}))
export default Flag
